import { httpPost } from "../http-requests";

export async function postSubscriber(email) {
    const response = await httpPost(`/api/subscriber?email=${email}`);
    return response;
}